/* IMPORT HERE */

import { ThemeUICSSObject } from 'theme-ui';

export const primary: ThemeUICSSObject = {
  background: 'white',
  border: '1px solid #ccc',
  borderRadius: 'tooltips',
  p: 3,
  zIndex: 'tooltip',
  /* PREPEND HERE */
};
